import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';


@Injectable()
export class forgotpasswordHTTPService {
    constructor(private http: HttpClient, public errorService: ErrorService) { }


    resetPassword(paramsData: URLSearchParams): Observable<any> {
        let url = "api/Auth/forgotPassword?";
        return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
          map(data => data.body),
          catchError(this.errorService.handleError)
        )
      }
}